// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__Uu8QC","closeButton":"styles_closeButton__wlHeJ","video":"styles_video__NToQa"};